import React, { useContext, useRef, useState } from "react";
import IdleTimer from "react-idle-timer";
import { AppStateContext } from "../../contexts/AppStateContext";
import SessionTimeoutDialog from './SessionTimeoutDialog';
import { useNavigate } from "react-router-dom";
let countdownInterval;
let timeout;

export default function SessionTimeout() {
  const navigate = useNavigate();
  const { isAuthenticated, handleLogoutUser } = useContext(
    AppStateContext
  );
  const [timeoutModalOpen, setTimeoutModalOpen] = useState(false);
  const [timeoutCountdown, setTimeoutCountdown] = useState(0);
  const idleTimer = useRef(null);

  const clearSessionTimeout = () => {
    clearTimeout(timeout);
  };

  const clearSessionInterval = () => {
    clearInterval(countdownInterval);
  };


  //   const clearSession = () => {
  //     dispatch(addUserDetails({}))
  //     dispatch(addFarmerInfo({}))
  //     dispatch(toggleMenu('hidden'))
  //     navigate("/login");
  // }


  const handleLogout = (isTimedOut = false) => {
    setTimeoutModalOpen(false);
    clearSessionInterval();
    clearSessionTimeout();
    handleLogoutUser(isTimedOut);
    sessionStorage.clear()
    localStorage.clear();
    navigate("/login");
  };


  const handleContinue = () => {
    setTimeoutModalOpen(false);
    clearSessionInterval();
    clearSessionTimeout();
  };

  const onActive = () => {
    if (!timeoutModalOpen) {
      clearSessionInterval();
      clearSessionTimeout();
    }
  };

  const onIdle = () => {
    const delay = process.env.REACT_APP_IDLE_DURATION;
    if (isAuthenticated && !timeoutModalOpen) {

      timeout = setTimeout(() => {
        let countDown = 60;
        setTimeoutModalOpen(true);
        setTimeoutCountdown(countDown);
        countdownInterval = setInterval(() => {
          if (countDown > 0) {
            setTimeoutCountdown(--countDown);
          } else {
            handleLogout(true);
          }
        }, 1000);
      }, delay);
    }
  };

  return (
    <>
      <IdleTimer
        ref={idleTimer}
        onActive={onActive}
        onIdle={onIdle}
        debounce={250}
        timeout={2000}
      />
      <SessionTimeoutDialog
        countdown={timeoutCountdown}
        onContinue={handleContinue}
        onLogout={() => handleLogout(false)}
        open={timeoutModalOpen}
      />

    </>
  );
}
